import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Container,
} from "@mui/material";
import Header from "src/Component/content-component/Header";
import ButtonComponent from "../content-component/ButtonComponent";

const ImmersionTabObjectives = ({ objectives, handleOpenDialog }) => {
  return (
    <Box sx={{ padding: "20px" }}>
      <Container>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 5 }}>
          <Header content={"Key Objectives"} textAlign={"center"} />
        </Box>

        <Grid
          container
          spacing={2}
          sx={{ display: "flex", justifyContent: "center" }}
        >
          {objectives.length > 0 ? (
            objectives.map((item, index) => (
              <Grid
                key={index}
                item
                lg={3}
                md={4}
                sm={6}
                xs={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Card
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    padding: "20px",
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                    borderRadius: "16px",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <CardContent>
                    <Box
                      component="img"
                      src={item.img}
                      alt={item.title}
                      sx={{
                        width: "80px",
                        height: "80px",
                        marginBottom: "16px",
                      }}
                    />
                    <Typography
                      sx={{
                        fontSize: "16px",
                        color: "#525560",
                        fontWeight: "bold",
                      }}
                    >
                      {item.title}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))
          ) : (
            <Typography
              sx={{ textAlign: "center", fontSize: "18px", color: "#FF0000" }}
            >
              No Objectives Available
            </Typography>
          )}
        </Grid>

        <Box sx={{ mt: { xs: 2, sm: 8 }, textAlign: "center" }}>
          <ButtonComponent
            width={"auto"}
            fontSize="20px"
            text="BOOK A COUNSELLING SESSION"
            onClick={handleOpenDialog}
          />
        </Box>
      </Container>
    </Box>
  );
};

export default ImmersionTabObjectives;
